export const getMillisecondsFromCssTime = (cssTime: string) => {
  const timeType = cssTime.substring(cssTime.length - 2);
  return timeType.toLowerCase() === 'ms'
    ? Number(cssTime.substring(0, cssTime.length - 2))
    : Number(cssTime.substring(0, cssTime.length - 1)) * 1000;
};
